  <div class="row mt-3">
    <div class="col-sm-12">

      <div class="row mt-2">
        <div class="col-sm-6">
          <span class="section-heading">My Details</span>
        </div>
        <div class="col-sm-6">
          <button class="action-button" (click)="editDetails()">
            Edit Details
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">

          <div class="row">
            <div class="col-sm-4">
              First name :
            </div>
            <div class="col-sm-8">
              {{ currentUser.firstName }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Last name :
            </div>
            <div class="col-sm-8">
              {{ currentUser.lastName }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Email :
            </div>
            <div class="col-sm-8">
              {{ currentUser.email }}
            </div>
          </div>

        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-6">
          <span class="section-heading">Company Details</span>
        </div>
        <div class="col-sm-6">
          <button class="action-button" (click)="editCompany()">
            Edit Company
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">

          <div class="row">
            <div class="col-sm-4">
              Name :
            </div>
            <div class="col-sm-8">
              {{ currentCompany.name }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Description :
            </div>
            <div class="col-sm-8">
              {{ currentCompany.description }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Contact person :
            </div>
            <div class="col-sm-8">
              {{ currentCompany.contactPerson }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Email :
            </div>
            <div class="col-sm-8">
              {{ currentCompany.email }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Contact number :
            </div>
            <div class="col-sm-8">
              {{ currentCompany.contactNumber }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Cell number:
            </div>
            <div class="col-sm-8">
              {{ currentCompany.cellNumber }}
            </div>
          </div>

        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-6">
          <span class="section-heading">Address Details</span>
        </div>
        <div class="col-sm-6">
          <button class="action-button" (click)="editAddress()">
            Edit Address
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">

          <div class="row">
            <div class="col-sm-4">
              Address line 1 :
            </div>
            <div class="col-sm-8">
              {{ currentAddress.addressLine1 }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Address line 2 :
            </div>
            <div class="col-sm-8">
              {{ currentAddress.addressLine2 }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Suburb :
            </div>
            <div class="col-sm-8">
              {{ currentAddress.suburb }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Province :
            </div>
            <div class="col-sm-8">
              {{ currentAddress.province.name }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              Postal code :
            </div>
            <div class="col-sm-8">
              {{ currentAddress.postcode }}
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <tan-modal #editDetailsModal [size]="'md'" [title]="'Edit My Details'" [showInformationBlock]="false"
    (onSave)="saveCustomer()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(updateCustomerLoading$ | async)" [loadingText]="'<p>Saving Customer Details</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(updateCustomerError$ | async) || showErrorMessage">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not edit Customer'"></tan-alert-message>
          </div>
        </div>

        <div class="row" *ngIf="!(updateCustomerError$ | async) && !(updateCustomerLoading$ | async)">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="customerForm">

                <div class="form-group">
                  <label class="control-label" for="first_name">First name</label>
                  <input type="text" class="form-control" formControlName="first_name" />
                  <span class="error"
                    *ngIf="customerForm.get('first_name').touched && customerForm.get('first_name').errors?.required">
                    First name is required</span>
                  <span class="error"
                    *ngIf="customerForm.get('first_name').touched && customerForm.get('first_name').errors?.maxlength">
                    First name cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="last_name">Last name</label>
                  <input type="text" class="form-control" formControlName="last_name" />
                  <span class="error"
                    *ngIf="customerForm.get('last_name').touched && customerForm.get('last_name').errors?.required">
                    Last name is required</span>
                  <span class="error"
                    *ngIf="customerForm.get('last_name').touched && customerForm.get('last_name').errors?.maxlength">
                    Last name cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input type="email" class="form-control" formControlName="email" />
                  <span class="error"
                    *ngIf="customerForm.get('email').touched && customerForm.get('email').errors?.email">Email
                    is invalid</span>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>

  <tan-modal #editCompanyModal [size]="'md'" [title]="'Edit Company Details'" [showInformationBlock]="false"
    (onSave)="saveCompany()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(updateCustomerCompanyLoading$ | async)" [loadingText]="'<p>Saving Company Details</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(updateCustomerCompanyError$ | async) || showErrorMessage">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not edit Company'"></tan-alert-message>
          </div>
        </div>

        <div class="row" *ngIf="!(updateCustomerCompanyError$ | async) && !(updateCustomerCompanyLoading$ | async)">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="companyForm">

                <div class="form-group">
                  <label class="control-label" for="name">Name</label>
                  <input type="text" class="form-control" formControlName="name" />
                  <span class="error"
                    *ngIf="companyForm.get('name').touched && companyForm.get('name').errors?.required">
                    Company name is required</span>
                  <span class="error"
                    *ngIf="companyForm.get('name').touched && companyForm.get('name').errors?.maxlength">
                    Company name cannot be more than 255 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="description">Description</label>
                  <textarea type="text" class="form-control" formControlName="description" rows="3"></textarea>
                </div>

                <div class="form-group">
                  <label class="control-label" for="contact_person">Contact person</label>
                  <input type="text" class="form-control" formControlName="contact_person" />
                  <span class="error"
                    *ngIf="companyForm.get('contact_person').touched && companyForm.get('contact_person').errors?.required">
                    Contact person is required</span>
                  <span class="error"
                    *ngIf="companyForm.get('contact_person').touched && companyForm.get('contact_person').errors?.maxlength">
                    Contact person cannot be more than 50 characters</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input type="email" class="form-control" formControlName="email" />
                  <span class="error"
                    *ngIf="companyForm.get('email').touched && companyForm.get('email').errors?.email">Email
                    is invalid</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="contact_number">Contact number</label>
                  <input type="text" class="form-control" formControlName="contact_number" />
                  <span class="error"
                    *ngIf="companyForm.get('contact_number').errors?.required && companyForm.get('contact_number').touched">
                    Contact number is required<br></span>
                  <span class="error"
                    *ngIf="companyForm.get('contact_number').touched && companyForm.get('contact_number').errors">
                    Number must be between 9 and 15 characters, and only contain numeric values</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="cell_number">Cell number</label>
                  <input type="text" class="form-control" formControlName="cell_number" />
                  <span class="error"
                    *ngIf="companyForm.get('cell_number').touched && companyForm.get('cell_number').errors">
                    Number must be between 9 and 15 characters, and only contain numeric values</span>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>

  <tan-modal #editAddressModal [size]="'md'" [title]="'Edit Address Details'" [showInformationBlock]="false"
    (onSave)="saveAddress()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(updateCustomerAddressLoading$ | async)" [loadingText]="'<p>Saving Address Details</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(updateCustomerAddressError$ | async) || showErrorMessage">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not update Address'"></tan-alert-message>
          </div>
        </div>

        <div class="row" *ngIf="!(updateCustomerAddressError$ | async) && !(updateCustomerAddressLoading$ | async)">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="addressForm">

                <div class="form-group">
                  <label class="control-label" for="address_line1">Address line 1</label>
                  <input type="text" class="form-control" formControlName="address_line1" />
                  <span class="error"
                    *ngIf="addressForm.get('address_line1').touched && addressForm.get('address_line1').errors?.required">
                    Address line 1 is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="address_line2">Address line 2</label>
                  <input type="text" class="form-control" formControlName="address_line2" />
                  <span class="error"
                    *ngIf="addressForm.get('address_line2').touched && addressForm.get('address_line2').errors?.required">
                    Address line 2 is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="suburb">Suburb</label>
                  <input type="text" class="form-control" formControlName="suburb" />
                  <span class="error"
                    *ngIf="addressForm.get('suburb').touched && addressForm.get('suburb').errors?.required">
                    Suburb is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="province">Province</label>
                  <select class="form-control" formControlName="province" id="province" (change)="setProvince()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
                  </select>
                  <span class="error"
                    *ngIf="addressForm.get('province').touched && addressForm.get('province').errors?.required">
                    Province is required</span>
                </div>

                <div class="form-group">
                  <label class="control-label" for="postcode">Postal code</label>
                  <input type="text" class="form-control" formControlName="postcode" />
                  <span class="error"
                    *ngIf="addressForm.get('postcode').touched && addressForm.get('postcode').errors?.required">
                    Postal code is required</span>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>